import api from './api';

class UserService {
  create(data){
    return api.post('/user/register',data);
  }
  update(data){
    return api.post('/user/update',data);
  }
  updateInfo(data){
    return api.patch('/user/info',data);
  }
  updatePassword(data){
    return api.patch('/user/password',data);
  }
 
  getPublicContent() {
    return api.get('/test/all');
  }

  getUserBoard() {
    return api.get('/test/user');
  }

  getModeratorBoard() {
    return api.get('/test/mod');
  }

  getAdminBoard() {
    return api.get('/test/admin');
  }

  getDataPage(params) {
      return api.get('/user/list',{params:params});

  }
  getList(params){
    return this.getDataPage(params);
  }
  getListGuide(params){
    return api.get('/user/list-guide',{params:params});
  }
  getStatistics(){
    return api
      .get("/user/statistics")
      .then((response) => {
          return response;
      });
  }
  get(params){
    return api.get('/user/detail',{params:params})
  }
  async importStaff(formData){
    return api
    .post("/user/import-staff",formData,
        {
          headers: {
           'Content-Type': 'multipart/form-data',
       }
        })
    .then((response) => {
      return response;
    });
  }
  destroys(ids){
    return this.destroy(ids);
  }
  destroy(uri, data){
    return api
        .delete(uri, data)
        .then((response) => {
          return response;
        });
  }

  destroyUser(data) {
    return api
    .delete("/user/"+data)
    .then((response) => {
        return response;
    });
  }

}

export default new UserService();
